import {
  CommonRequest,
  CommonResponse,
  DmlResponse,
  Method,
  ServiceName,
} from 'models/common/RestApi';
import { MdLine, MdLineCondition } from 'models/md/MdLine';
import { callApi } from 'utils/ApiUtil';

/**
 * 형개발 투자비 산출 등록 > 프로젝트 정보 > 라인 추가 팝업 - 형개발라인 정보 목록 조회
 * @param elmPrjId
 * @returns
 */
export const findMdLineListForInvest = async (condition: MdLineCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/line-invest`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdLine[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdLine[];
};

/**
 * 기준정보 > 형개발라인 정보 목록 조회
 * @param elmPrjId
 * @returns
 */
export const findMdLineList = async (condition: MdLineCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/line`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdLine[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdLine[];
};

/**
 * 기준정보 > 형개발라인 정보 목록 저장
 * @param mdLines
 */
export const saveMdLineList = async (mdLines: MdLine[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/line`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: mdLines,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};
